import React, { Component,useState } from 'react';
import { Trans } from "react-i18next";
import { CardElement,useElements,useStripe } from "@stripe/react-stripe-js";
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import axios from 'axios';
import Loader from 'react-loader-spinner'; 
//import { useHistory } from "react-router-dom"; 

const PaymentForm = (props) => {
 // const history = useHistory()
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [modal5, setModal] = useState(false);
  const [modal4, setModall] = useState(false);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const stripe = useStripe();
  const elements = useElements();

  const language = props.language;
  const currency_code = props.currency_code;
  const purchase_type = props.purchase_type;
  const amount = props.amount;
  const auto_renewal = props.auto_renewal;
  const api_url = localStorage.getItem('api_url');
  //console.log(language + " " + currency_code + " " + purchase_type + " " + auto_renewal + ' ' + amount);

  const createSubscription = async () => {

    setLoader(true);
    setError('');

     if(name == '' || email == '' ){

        setLoader(false);

        setTimeout(() => {
        setError('Please fill all the details');
        }, 2000);  
      
     }else{


     try {
              const paymentMethod = await stripe.createPaymentMethod({
                card: elements.getElement("card"),
                type: "card",
              });
      //console.log(paymentMethod.paymentMethod.id);
      //alert(paymentMethod.paymentMethod.id);

        var item_id = 0;
        let data = new FormData();
        data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));  
        data.append('language', language); 
        data.append('currency_code', currency_code); 
        data.append('amount', amount); 
        data.append('purchase_type', purchase_type); 
        data.set('auto_renewal', auto_renewal);
        if(purchase_type=='premium'){
            item_id = JSON.parse(localStorage.getItem('selected_premium')); 
        }
        else if(purchase_type=='boost'){
            item_id = JSON.parse(localStorage.getItem('selected_boostpremium'));
        }
        else if(purchase_type=='superlike'){
            item_id = JSON.parse(localStorage.getItem('selected_superlikepremium'));
        }
        else if(purchase_type=='banner'){
            item_id = JSON.parse(localStorage.getItem('banner_id'));
        }
        data.append('item_id', item_id);
        data.append('name', name);
        data.append('email', email);
        data.append('payment_method', paymentMethod.paymentMethod.id);

        axios({
            method: 'post',
            url: api_url+'createstripeautorenewal',
            data: data, 
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
          console.log(res.data);
          console.log(res.data.status);
             if(res.data.status != 'false') { 
                 
              if (res.data.type == "premium") {                  
                    localStorage.setItem('premium_popup', '1');
                    setModal(true);
                    setMessage(res.data.message);
                   
              }else{    
                    setModal(true);
                    setMessage(res.data.message);  
             }
          } 
          else {
            setLoader(false);
            setModall(true);
            setMessage(res.data.message);

          }
          }); 

      
    } catch (err) {
      //console.error(err);
          if(err.message == "Cannot read properties of undefined (reading 'id')"){
                setLoader(false);
               //alert("Please fill the card details! ");
                setError('Please fill the card details correctly');

          }else{
            setLoader(false);
          //alert("Payment failed! " + err.message);
          setError(err.message);
        }
    }
}

     
  };

  const closeModal = async () => {
        setModal(false);
         //props.history.replace("/app"); 
        //window.location.reload();
        var web_url = localStorage.getItem('web_url'); 
        window.location = web_url + "app";
  }; 

  const closeModall = async () => {
        setModall(false);        
       // window.location = "/app";
  };  

  return (
    <div className="setting-page">
             
                         <div className="user-input-wrp amb25">
                                   <br/><br/>
                                     <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} className="inputText" placeholder=" " required />
                                    <span className="floating-label"><Trans i18nKey="Name">Name</Trans></span>
                                </div>

                        <div className="user-input-wrp amb25">
                                    <br /><br/>
                                    <input  type="email" id="email"  value={email} onChange={(e) => setEmail(e.target.value)}  className="inputText" required />
                                    <span className="floating-label"><Trans i18nKey="Email">Email</Trans></span>
                        </div>

                        <span className="floating-label"><Trans i18nKey="Card Details">Card Details</Trans></span><br/><br/>
                                
                              <CardElement />
                              
                          <br />

                    <div class="d-flex">

                        <div class="mr-6"  style={{ color: "red" }}>
                        {error}
                        </div>
                    </div>
                    
                        <div class="d-flex justify-content-end">                        
                            <div class="mr-3">

                            { loader == false 

                            ?
                              <button onClick={createSubscription} class="btn-common d-flex mx-auto" >Proceed Payment</button>
                            :
                              <div className="circularIcoHolder addphoto">    
                                  <Loader type="Bars" color="#ffffff" height={20} width={35} />
                             </div>
                           }
                      </div>
                    </div>

                   <Modal isOpen={modal5} toggle={closeModal.bind(this, 'modal5')} className="premiumPopup vertically-center apd5">
                    <ModalHeader toggle={closeModal.bind(this, 'modal5')}><h4 class="modal-title" style={{'marginTop':"10px"}}><Trans i18nKey={message}>{message}</Trans></h4></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div class="d-flex justify-content-end">
                                <div class="mr-3"><button class="border-0 bg-white pink-color" onClick={closeModal.bind(this, 'modal5')}><Trans i18nKey="Ok">Ok</Trans></button></div>
                            </div>
                        </div>
                    </ModalBody> 
                </Modal> 

                <Modal isOpen={modal4} toggle={closeModall.bind(this, 'modal4')} className="premiumPopup vertically-center apd5">
                    <ModalHeader toggle={closeModall.bind(this, 'modal4')}><h4 class="modal-title" style={{'marginTop':"10px"}}><Trans i18nKey={message}>{message}</Trans></h4></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div class="d-flex justify-content-end">
                                <div class="mr-3"><button class="border-0 bg-white pink-color" onClick={closeModall.bind(this, 'modal4')}><Trans i18nKey="Ok">Ok</Trans></button></div>
                            </div>
                        </div>
                    </ModalBody> 
                </Modal> 
            
      </div>
  );
}

export default PaymentForm;